import server from 'utils/server';

export type ReleaseAlertStatus = 'pending_confirmation' | 'active' | 'notified' | 'withdrawn' | 'expired';

/** A release alert as the API lists it for the team (no tokens). */
export type ReleaseAlert = {
  id: string;
  status: ReleaseAlertStatus;
  dateFrom: string;
  dateTo: string;
  language: 'de' | 'en';
  contact: { name: string; email: string; phone?: string | null };
  channels?: { sms: boolean };
  createdAt: number;
  confirmedAt: number | null;
  notified: { from: string; to: string; at: number; openSpans?: { from: string; to: string }[] } | null;
  endedBy: string | null;
};

export type ReleaseAlertSettings = { enabled: boolean; smsEnabled: boolean };

const base = (restaurantId: string) => `/v03/releaseAlerts/team/${encodeURIComponent(restaurantId)}`;

export const releaseAlertApi = {
  list: async (restaurantId: string) =>
    ((await server.get(base(restaurantId))) as { data: { alerts: ReleaseAlert[] } }).data.alerts,
  settings: async (restaurantId: string) =>
    ((await server.get(`${base(restaurantId)}/settings`)) as { data: ReleaseAlertSettings }).data,
  saveSettings: async (restaurantId: string, settings: ReleaseAlertSettings) =>
    ((await server.post(`${base(restaurantId)}/settings`, settings)) as { data: ReleaseAlertSettings }).data,
  withdraw: async (restaurantId: string, alertId: string) =>
    ((await server.post(`${base(restaurantId)}/${encodeURIComponent(alertId)}/withdraw`)) as { data: ReleaseAlert })
      .data,
};
